import React from 'react';
import { motion } from 'framer-motion';
export function ReviewsSection() {
  const reviews = [{
    name: 'María González',
    role: 'Coach de Negocios',
    text: 'Pasé de publicar 2 veces por semana a tener TODO el mes programado. El método R.I.C.E. cambió completamente cómo uso ChatGPT. Mis clientes notan la diferencia en la calidad.'
  }, {
    name: 'Carlos Ramírez',
    role: 'Consultor de Marketing',
    text: 'Escéptico al principio, pero los 50 prompts son oro puro. En mi primera sesión de 4 horas produje contenido para 5 semanas. ROI infinito por $9.99.'
  }, {
    name: 'Ana Martínez',
    role: 'Emprendedora Digital',
    text: 'Por fin puedo enfocarme en vender y no en crear contenido. La técnica de Muestreo de Estilo es brillante — la IA ahora escribe exactamente como yo hablo.'
  }, {
    name: 'Diego López',
    role: 'Freelancer',
    text: 'Probé 3 cursos de IA antes y ninguno me dio resultados. Este ebook es diferente porque es un SISTEMA, no solo teoría. Lo implementé en un fin de semana.'
  }, {
    name: 'Valentina Torres',
    role: 'Dueña de E-commerce',
    text: 'Mi engagement subió 340% en el primer mes. El framework de multiplicación omnicanal es genial — un post se convierte en 5 piezas diferentes.'
  }];
  return <section className="py-28 px-6 bg-darker text-center" data-id="element-267">
      <div className="max-w-[1200px] mx-auto" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16" data-id="element-269">
          <span className="inline-block text-gold text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-270">
            ⭐ Lo que dicen nuestros alumnos
          </span>
          <h2 className="text-[clamp(28px,4vw,48px)] font-black text-white" data-id="element-271">
            Resultados reales de personas reales
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-left" data-id="element-272">
          {reviews.map((review, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.1
        }} className="bg-cardBg border border-border rounded-2xl p-6 flex flex-col h-full" data-id="element-273">
              <div className="text-gold text-[18px] tracking-widest mb-4" data-id="element-274">
                ★★★★★
              </div>
              <p className="text-[#CCCCCC] text-[14px] italic leading-relaxed flex-grow mb-6" data-id="element-275">
                "{review.text}"
              </p>
              <hr className="border-t border-border mb-4" data-id="element-276" />
              <div data-id="element-277">
                <p className="font-bold text-white text-[15px]" data-id="element-278">
                  {review.name}
                </p>
                <p className="text-[13px] text-[#888] mb-1" data-id="element-279">{review.role}</p>
                <p className="text-green text-[11px] font-semibold flex items-center gap-1" data-id="element-280">
                  ✓ Compra verificada
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}